import React from "react";

const DescrptionEducationSession = () => {
  return (
    <div className="awareness-container">
      <div className="awareness-hero">
        <h1 className="awareness-subtitle">Make a Real Difference</h1>
        <h1 className="awareness-title">
          Organise a <span className="pinkhighlig">Health Awareness Session</span>
        </h1>
      </div>

      <div className="awareness-content">
        <p>
          Dr Planete helps you connect with doctors and hospitals in your area to conduct impactful
          health awareness sessions. Be it a <strong>school, college, office, industry</strong> or
          <strong> residential society</strong> — if you care about community wellbeing, this is your chance
          to act.
        </p>

        <p>
          Planning a session on <strong>mental health</strong> for employees?</p>
          <p> Want to teach students about
          <strong> hygiene, nutrition or menstruation ?</strong></p>
          <p>Looking to organise a general talk on
          <strong> diabetes, heart health or PCOS awareness</strong> for the public?</p>
          <p> Post your
          requirement and dr planete members (doctors & hospitals) will directly reach out to you.
        </p>

        <p>
          Let’s build a healthier society, one session at a time. <strong>Post your request today.</strong>
        </p>
      </div>
    </div>
  );
};

export default DescrptionEducationSession;

// CSS styles (in the same file)
const style = document.createElement("style");
style.innerHTML = `
  .awareness-container {
    margin: 0 auto;
    width:100%;
    font-family: 'Poppins', sans-serif;
  }

  .awareness-hero {
    background: black;
    text-align: center;
    padding: 2rem 1rem;
    border-radius: 0px;
    margin-bottom: 2rem;
  }

  .awareness-subtitle {
    color: black;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .awareness-title {
    font-size: 50px;
    color: white;
    font-weight: 700;
  }

  .pinkhighlig {
    color: #FF4081;
  }

  .awareness-content {
    font-size: 18px;
    line-height: 1.6;
    color: #333;
    padding: 0 1rem;
  }

  @media (max-width: 768px) {
    .awareness-title {
      font-size: 36px;
    }

    .awareness-subtitle {
      font-size: 20px;
    }

    .awareness-content {
      font-size: 19px;
    }
  }
`;
document.head.appendChild(style);
